
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Store from '../pages/store/page';
import Auth from '../pages/auth/page';
import Splash from '../pages/splash/page';
import Cart from '../pages/cart/page';
import Checkout from '../pages/checkout/page';
import Orders from '../pages/orders/page';
import TrackOrder from '../pages/track-order/page';
import Profile from '../pages/profile/page';
import OrderConfirmation from '../pages/order-confirmation/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Splash />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/store/:storeId',
    element: <Store />
  },
  {
    path: '/auth',
    element: <Auth />
  },
  {
    path: '/cart',
    element: <Cart />
  },
  {
    path: '/checkout',
    element: <Checkout />
  },
  {
    path: '/orders',
    element: <Orders />
  },
  {
    path: '/track-order/:orderId',
    element: <TrackOrder />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/order-confirmation',
    element: <OrderConfirmation />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
